export default "__VITE_ASSET__s34VTPnN__"